<div class="subnav" [ngClass]="{'dark': darkMode}">
    <ul class="subnav-list">
        <li class="subnav-list-item" *ngFor="let listItem of listItems">
            <app-admin-subnav-list-item [listItem]="listItem" [darkMode]="darkMode"></app-admin-subnav-list-item>
        </li>
    </ul>
</div>
